import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import './RMCInviteAccept.css';

const RMCInviteAccept = () => {
  const { token } = useParams();
  const { user, updateUser } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();

  const [accepting, setAccepting] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const [error, setError] = useState('');

  // If user is already an RMC member, show message
  const alreadyMember = user?.rmc_enabled;

  const handleAccept = async () => {
    setAccepting(true);
    setError('');
    try {
      await axios.post(`/api/rmc/invitations/accept/${token}`);
      updateUser({ ...user, rmc_enabled: true });
      setAccepted(true);
      setTimeout(() => navigate('/rmc'), 3000);
    } catch (err) {
      const msg = err.response?.data?.error || '';
      if (msg.includes('already used')) {
        setError(t('rmc.invite.alreadyUsed'));
      } else if (msg.includes('not found')) {
        setError(t('rmc.invite.notFound'));
      } else {
        setError(msg || t('rmc.invite.notFound'));
      }
    } finally {
      setAccepting(false);
    }
  };

  if (accepted) {
    return (
      <div className="rmc-invite-page">
        <div className="rmc-invite-card">
          <div className="rmc-invite-icon success">✅</div>
          <h2>{t('rmc.invite.accepted')}</h2>
          <p className="rmc-invite-redirect">{t('rmc.invite.redirecting')}</p>
        </div>
      </div>
    );
  }

  if (alreadyMember) {
    return (
      <div className="rmc-invite-page">
        <div className="rmc-invite-card">
          <div className="rmc-invite-icon">🏆</div>
          <h2>{t('rmc.access.alreadyMember')}</h2>
          <button className="btn btn-primary" onClick={() => navigate('/rmc')}>
            {t('rmc.rules.backToDashboard')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="rmc-invite-page">
      <div className="rmc-invite-card">
        <div className="rmc-invite-header">
          <h1>Rouvy Mamiky's Championship</h1>
          <p className="rmc-invite-season">{t('rmc.season')}</p>
        </div>

        <div className="rmc-invite-body">
          <div className="rmc-invite-icon">✉️</div>
          <h2>{t('rmc.invite.title')}</h2>
          <p>{t('rmc.invite.desc')}</p>

          {error && <div className="error-message">{error}</div>}

          {user ? (
            <button
              className="btn btn-primary rmc-invite-accept-btn"
              onClick={handleAccept}
              disabled={accepting}
            >
              {accepting ? t('rmc.invite.accepting') : t('rmc.invite.accept')}
            </button>
          ) : (
            <div className="rmc-invite-auth">
              <p className="rmc-invite-auth-note">{t('rmc.invite.loginFirst')}</p>
              <div className="rmc-invite-auth-btns">
                <Link
                  to="/login"
                  state={{ from: `/rmc/invite/${token}` }}
                  className="btn btn-primary"
                >
                  {t('rmc.invite.loginToAccept')}
                </Link>
                <Link
                  to="/signup"
                  state={{ from: `/rmc/invite/${token}` }}
                  className="btn btn-secondary"
                >
                  {t('rmc.invite.registerToAccept')}
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RMCInviteAccept;
